import { render, staticRenderFns } from "./DeletedEventsGrid.vue?vue&type=template&id=bec88f66"
import script from "./DeletedEventsGrid.vue?vue&type=script&lang=js"
export * from "./DeletedEventsGrid.vue?vue&type=script&lang=js"
import style0 from "./DeletedEventsGrid.vue?vue&type=style&index=0&id=bec88f66&prod&lang=css"
import style1 from "./DeletedEventsGrid.vue?vue&type=style&index=1&id=bec88f66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports